import React from 'react';

export const lineChartData = [
    [
        {name: 'J', amt: 24244},
        {name: 'F', amt: 18123},
        {name: 'M', amt: 22765},
        {name: 'A', amt: 17097},
        {name: 'M', amt: 25529},
        {name: 'J', amt: 18669},
        {name: 'J', amt: 21812},
        {name: 'S', amt: 14988},
        {name: 'O', amt: 18693},
        {name: 'N', amt: 22900},
        {name: 'D', amt: 25313},
    ]
];

export const data = [
    {name: 'Let A', uv: 0, pv: 0, amt: 20},
    {name: 'Let B', uv: 30, pv: 13, amt: 21},
    {name: 'Let C', uv: 20, pv: 98, amt: 29},
    {name: 'Let D', uv: 27, pv: 39, amt: 20},
    {name: 'Let E', uv: 18, pv: 48, amt: 28},
    {name: 'Let F', uv: 23, pv: 38, amt: 20},
    {name: 'Let G', uv: 0, pv: 0, amt: 20},
];

export const data1 = [
    {name: 'Let A', uv: 40, pv: 24, amt: 20},
    {name: 'Let B', uv: 30, pv: 13, amt: 21},
    {name: 'Let C', uv: 60, pv: 98, amt: 29},
    {name: 'Let D', uv: 27, pv: 39, amt: 20},
    {name: 'Let E', uv: 78, pv: 48, amt: 28},
    {name: 'Let F', uv: 23, pv: 38, amt: 20},
    {name: 'Let G', uv: 56, pv: 43, amt: 20},
];
export const data2 = [
    {name: 'Let A', uv: 40, pv: 24, amt: 20},
    {name: 'Let B', uv: 10, pv: 13, amt: 21},
    {name: 'Let C', uv: 60, pv: 98, amt: 29},
    {name: 'Let D', uv: 27, pv: 15, amt: 20},
    {name: 'Let E', uv: 56, pv: 45, amt: 28},
    {name: 'Let F', uv: 23, pv: 56, amt: 20},
    {name: 'Let G', uv: 56, pv: 43, amt: 20},
];
export const radarChartData = [
    {subject: 'Math', A: 120, B: 110, fullMark: 150},
    {subject: 'Chinese', A: 98, B: 130, fullMark: 150},
    {subject: 'English', A: 86, B: 130, fullMark: 150},
    {subject: 'Geography', A: 99, B: 100, fullMark: 150},
    {subject: 'Physics', A: 85, B: 90, fullMark: 150},
    {subject: 'History', A: 65, B: 85, fullMark: 150},
];
export const chartData = [
    {name: 'J', amt: 1400},
    {name: 'F', amt: 2210},
    {name: 'M', amt: 1000},
    {name: 'A', amt: 2000},
    {name: 'M', amt: 1400},
    {name: 'J', amt: 2300},
    {name: 'J', amt: 500},
    {name: 'A', amt: 2000},
    {name: 'S', amt: 1500},
    {name: 'S', amt: 1500},
    {name: 'O', amt: 1000},
    {name: 'N', amt: 2000},
    {name: 'D', amt: 500}

];

export const chartDataWithoutAxis = [
    {name: 'J', amt: 1400},
    {name: 'F', amt: 2210},
    {name: 'M', amt: 1000},
    {name: 'A', amt: 2000},
    {name: 'M', amt: 1400},
    {name: 'J', amt: 2300},
    {name: 'J', amt: 500},
    {name: 'A', amt: 2000},
    {name: 'S', amt: 1500},
    {name: 'O', amt: 1000},
    {name: 'N', amt: 2000},
    {name: 'D', amt: 500},
    {name: 'M', amt: 1000},
    {name: 'A', amt: 2000},
    {name: 'M', amt: 1400},

];

export const pieChartData = [
    {name: 'J', amt: 24},
    {name: 'F', amt: 18},
    {name: 'M', amt: 22},
    {name: 'A', amt: 17},
    {name: 'M', amt: 25},
    {name: 'J', amt: 12},
    {name: 'J', amt: 21},
];
export const radialData = [
    {name: 'Monthly Data', data: 48845, fill: '#3367d6'},
    {name: 'Orders Weekly', data: 8875, fill: '#83a6ed'},
    {name: 'Average Revenue', data: 21342, fill: '#8dd1e1'},
    {name: 'Total Revenue', data: 51875, fill: '#ffc658'},
    {name: 'Total Orders', data: 9223, fill: '#a4de6c'},
    {name: 'Past Orders', data: 8543, fill: '#d0ed57'},
];
export const products = [
    {
        image: 'http://via.placeholder.com/600x450',
        title: "Up unpacked friendly",
        description: "Contrary to popular belief, Lorem Ipsum is not simply random text.",
        mrp: 250,
        offerPrice: 200
    },
    {
        image: 'http://via.placeholder.com/500x330',
        title: "It allowance prevailed",
        description: "It is a long established fact that a reader will be distracted",
        mrp: 250,
        offerPrice: 200
    },
    {
        image: 'http://via.placeholder.com/500x330',
        title: "Case read they must",
        description: "There are many variations of passages of Lorem Ipsum available",
        mrp: 250,
        offerPrice: 200
    },
    {
        image: 'http://via.placeholder.com/500x330',
        title: "Too carriage attended",
        description: "The standard chunk of Lorem Ipsum used since the 1500s",
        mrp: 250,
        offerPrice: 200
    },
];


export const customers = [
    {
        id: 1,
        image: 'http://via.placeholder.com/150x150',
        name: "John Smith",
        about: "@john.s",
        detail: "3 orders",
        color: "success"
    },
    {
        id: 2,
        image: 'http://via.placeholder.com/150x150',
        name: "alex dolgove",
        about: "@Alex.Dolgove",
        detail: "2 orders",
        color: "primary"
    },
    {
        id: 3,
        image: 'http://via.placeholder.com/150x150',
        name: "Domnic Brown",
        about: "@domnic.brown",
        detail: "0 orders",
        color: "danger"
    },
    {
        id: 4,
        image: 'http://via.placeholder.com/150x150',
        name: "Jimmy jo",
        about: "@jimmy.jo",
        detail: "1 orders",
        color: "primary"
    }
];

export const appNotification = [

    {
        id: 1,
        title: "NEW ORDER",
        desc: [<a href="javascript:void(0)">Stella</a>, " has placed an order for 3 items of $234.0"],
        image: 'http://via.placeholder.com/150x150'
    },
    {
        id: 2,
        title: "Support ticket",
        desc: [<a href="javascript:void(0)">Jeson Born</a>, " raised a support ticket"],
        image: 'http://via.placeholder.com/150x150'
    },
    {
        id: 3,
        title: "new enquiry",
        desc: [<a href="javascript:void(0)">Guptil</a>, " has placed an order for 5 items of $425.0"],
        image: 'http://via.placeholder.com/150x150'
    },
    {
        id: 4,
        title: "NEW ORDER",
        desc: [<a href="javascript:void(0)">Alex Dolgove</a>, " raised a support ticket"],
        image: 'http://via.placeholder.com/150x150'
    },
];

export const announcementsNotification = [
    {
        id: 5,
        title: "NEW ORDER",
        desc: [<a href="javascript:void(0)">Alex Dolgove</a>, " raised a support ticket"],
        image: 'http://via.placeholder.com/150x150'
    },
    {
        id: 6,
        title: "Support ticket",
        desc: [<a href="javascript:void(0)">Jeson Born</a>, " raised a support ticket"],
        image: 'http://via.placeholder.com/150x150'
    },
    {
        id: 7,
        title: "NEW ORDER",
        desc: [<a href="javascript:void(0)">Stella</a>, " has placed an order for 3 items of $234.0"],
        image: 'http://via.placeholder.com/150x150'
    },
    {
        id: 8,
        title: "new enquiry",
        desc: [<a href="javascript:void(0)">Guptil</a>, " has placed an order for 5 items of $425.0"],
        image: 'http://via.placeholder.com/150x150'
    },
];

export const marketingData = [
    {
        id: 1,
        name: 'Facebook Ads',
        desc: '63 Likes, 387 Shares',
        icon: 'facebook',
        color: 'bg-indigo lighten-1',
        budget: 570,
        growth: 20
    },

    {
        id: 2,
        name: 'Twitter Ads',
        desc: '43 Likes, 545 Shares',
        icon: 'twitter',
        color: 'bg-light-blue accent-2',
        budget: 811,
        growth: -5
    },

    {
        id: 3,
        name: 'Instagram',
        desc: '83 Follows, 210 Likes',
        icon: 'instagram',
        color: 'bg-brown lighten-1',
        budget: 685,
        growth: 20
    },

    {
        id: 4,
        name: 'LinkedIn',
        desc: '23 Shares, 764 Likes',
        icon: 'linkedin',
        color: 'bg-light-blue darken-3',
        budget: 868,
        growth: 25
    },
    {
        id: 5,
        name: 'Youtube',
        desc: '1.2k subscribe, 1.8M Likes',
        icon: 'youtube',
        color: 'bg-red accent-4',
        budget: 780,
        growth: 45
    },

    {
        id: 6,
        name: 'Dribbble',
        desc: '23 Shares, 1.4k Likes',
        icon: 'dribbble',
        color: 'bg-pink lighten-2',
        budget: 868,
        growth: 25
    },

];

export const ganttData = {
    'data': [
      {
        'id': 1,
        'text': 'Office itinerancy',
        'type': 'project',
        'order': '10',
        'progress': 0.4,
        'open': false,
        'user':'0',
        'start_date': '02-04-2017 00:00',
        'duration': 17,
        'end_date': '19-04-2017 00:00',
        'parent': 0
      },
      {
        'id': 2,
        'text': 'Office facing',
        'type': 'project',
        'start_date': '02-04-2017 00:00',
        'duration': 8,
        'order': '10',
        'progress': 0.6,
        'user':'0',
        'parent': '1',
        'open': true,
        'end_date': '10-04-2017 00:00'
      },
      {
        'id': 5,
        'text': 'Interior office',
        'start_date': '02-04-2017 00:00',
        'duration': 7,
        'order': '3',
        'parent': '2',
        'progress': 0.6,
        'open': true,
        'user':'1',
        'end_date': '09-04-2017 00:00'
      },
      {
        'id': 6,
        'text': 'Air conditioners check',
        'start_date': '03-04-2017 00:00',
        'duration': 7,
        'order': '3',
        'parent': '2',
        'progress': 0.6,
        'open': true,
        'user':'2',
        'end_date': '10-04-2017 00:00'
      },
      {
        'id': 3,
        'text': 'Furniture installation',
        'type': 'project',
        'start_date': '11-04-2017 00:00',
        'duration': 8,
        'order': '20',
        'parent': '1',
        'progress': 0.6,
        'user':'0',
        'open': true,
        'end_date': '19-04-2017 00:00'
      },
      {
        'id': 7,
        'text': 'Workplaces preparation',
        'start_date': '11-04-2017 00:00',
        'duration': 8,
        'order': '3',
        'parent': '3',
        'progress': 0.6,
        'user':'0',
        'open': true,
        'end_date': '19-04-2017 00:00'
      },
      {
        'id': 4,
        'text': 'The employee relocation',
        'type': 'project',
        'start_date': '14-04-2017 00:00',
        'duration': 5,
        'order': '30',
        'parent': '1',
        'progress': 0.5,
        'user':'0',
        'open': true,
        'end_date': '19-04-2017 00:00'
      },
      {
        'id': 8,
        'text': 'Preparing workplaces',
        'start_date': '14-04-2017 00:00',
        'duration': 5,
        'order': '3',
        'parent': '4',
        'progress': 0.5,
        'user':'2',
        'open': true,
        'end_date': '19-04-2017 00:00'
      },
      {
        'id': 9,
        'text': 'Workplaces importation',
        'start_date': '14-04-2017 00:00',
        'duration': 4,
        'order': '3',
        'parent': '4',
        'progress': 0.5,
        'user':'0',
        'open': true,
        'end_date': '18-04-2017 00:00'
      },
      {
        'id': 10,
        'text': 'Workplaces exportation',
        'start_date': '14-04-2017 00:00',
        'duration': 3,
        'order': '3',
        'parent': '4',
        'progress': 0.5,
        'user':'3',
        'open': true,
        'end_date': '17-04-2017 00:00'
      },
      {
        'id': 11,
        'text': 'Product launch',
        'type': 'project',
        'order': '5',
        'progress': 0.6,
        'open': true,
        'user':'0',
        'start_date': '02-04-2017 00:00',
        'duration': 13,
        'end_date': '15-04-2017 00:00',
        'parent': 0
      },
      {
        'id': 12,
        'text': 'Perform Initial testing',
        'start_date': '03-04-2017 00:00',
        'duration': 5,
        'order': '3',
        'parent': '11',
        'progress': 1,
        'user':'0',
        'open': true,
        'end_date': '08-04-2017 00:00'
      },
      {
        'id': 13,
        'text': 'Development',
        'type': 'project',
        'start_date': '03-04-2017 00:00',
        'duration': 11,
        'order': '3',
        'parent': '11',
        'progress': 0.5,
        'user':'0',
        'open': true,
        'end_date': '14-04-2017 00:00'
      },
      {
        'id': 17,
        'text': 'Develop System',
        'start_date': '03-04-2017 00:00',
        'duration': 2,
        'order': '3',
        'parent': '13',
        'progress': 1,
        'user':'3',
        'open': true,
        'end_date': '05-04-2017 00:00'
      },
      {
        'id': 25,
        'text': 'Beta Release',
        'start_date': '06-04-2017 00:00',
        'order': '3',
        'type': 'milestone',
        'parent': '13',
        'progress': 0,
        'open': true,
        'user':'0',
        'end_date': '06-04-2017 00:00',
        'duration': 0
      },
      {
        'id': 18,
        'text': 'Integrate System',
        'start_date': '08-04-2017 00:00',
        'duration': 2,
        'order': '3',
        'parent': '13',
        'progress': 0.8,
        'open': true,
        'user':'1',
        'end_date': '10-04-2017 00:00'
      },
      {
        'id': 19,
        'text': 'Test',
        'start_date': '10-04-2017 00:00',
        'duration': 4,
        'order': '3',
        'parent': '13',
        'progress': 0.2,
        'open': true,
        'user':'0',
        'end_date': '14-04-2017 00:00'
      },
      {
        'id': 20,
        'text': 'Marketing',
        'start_date': '10-04-2017 00:00',
        'duration': 4,
        'order': '3',
        'parent': '13',
        'progress': 0,
        'user':'3',
        'open': true,
        'end_date': '14-04-2017 00:00'
      },
      {
        'id': 14,
        'text': 'Analysis',
        'start_date': '02-04-2017 00:00',
        'duration': 6,
        'order': '3',
        'parent': '11',
        'progress': 0.8,
        'user':'0',
        'open': true,
        'end_date': '08-04-2017 00:00'
      },
      {
        'id': 15,
        'text': 'Design',
        'type': 'project',
        'start_date': '03-04-2017 00:00',
        'duration': 5,
        'order': '3',
        'parent': '11',
        'progress': 0.2,
        'user':'0',
        'open': false,
        'end_date': '08-04-2017 00:00'
      },
      {
        'id': 21,
        'text': 'Design database',
        'start_date': '03-04-2017 00:00',
        'duration': 4,
        'order': '3',
        'parent': '15',
        'progress': 0.5,
        'user':'0',
        'open': true,
        'end_date': '07-04-2017 00:00'
      },
      {
        'id': 22,
        'text': 'Software design',
        'start_date': '03-04-2017 00:00',
        'duration': 4,
        'order': '3',
        'parent': '15',
        'progress': 0.1,
        'user':'2',
        'open': true,
        'end_date': '07-04-2017 00:00'
      },
      {
        'id': 23,
        'text': 'Interface setup',
        'start_date': '03-04-2017 00:00',
        'duration': 5,
        'order': '3',
        'parent': '15',
        'progress': 0,
        'user':'3',
        'open': true,
        'end_date': '08-04-2017 00:00'
      },
      {
        'id': 16,
        'text': 'Documentation creation',
        'start_date': '02-04-2017 00:00',
        'duration': 7,
        'order': '3',
        'parent': '11',
        'progress': 0,
        'user':'2',
        'open': true,
        'end_date': '09-04-2017 00:00'
      },
      {
        'id': 24,
        'text': 'Release v1.0',
        'start_date': '15-04-2017 00:00',
        'order': '3',
        'type': 'milestone',
        'parent': '11',
        'progress': 0,
        'open': true,
        'user':'0',
        'end_date': '15-04-2017 00:00',
        'duration': 0
      }
    ],
    'links': [
      {
        'id': '1',
        'source': '1',
        'target': '2',
        'type': '1'
      },
      {
        'id': '2',
        'source': '2',
        'target': '3',
        'type': '0'
      },
      {
        'id': '3',
        'source': '3',
        'target': '4',
        'type': '0'
      },
      {
        'id': '4',
        'source': '2',
        'target': '5',
        'type': '2'
      },
      {
        'id': '5',
        'source': '2',
        'target': '6',
        'type': '2'
      },
      {
        'id': '6',
        'source': '3',
        'target': '7',
        'type': '2'
      },
      {
        'id': '7',
        'source': '4',
        'target': '8',
        'type': '2'
      },
      {
        'id': '8',
        'source': '4',
        'target': '9',
        'type': '2'
      },
      {
        'id': '9',
        'source': '4',
        'target': '10',
        'type': '2'
      },
      {
        'id': '10',
        'source': '11',
        'target': '12',
        'type': '1'
      },
      {
        'id': '11',
        'source': '11',
        'target': '13',
        'type': '1'
      },
      {
        'id': '12',
        'source': '11',
        'target': '14',
        'type': '1'
      },
      {
        'id': '13',
        'source': '11',
        'target': '15',
        'type': '1'
      },
      {
        'id': '14',
        'source': '11',
        'target': '16',
        'type': '1'
      },
      {
        'id': '15',
        'source': '13',
        'target': '17',
        'type': '1'
      },
      {
        'id': '16',
        'source': '17',
        'target': '25',
        'type': '0'
      },
      {
        'id': '17',
        'source': '18',
        'target': '19',
        'type': '0'
      },
      {
        'id': '18',
        'source': '19',
        'target': '20',
        'type': '0'
      },
      {
        'id': '19',
        'source': '15',
        'target': '21',
        'type': '2'
      },
      {
        'id': '20',
        'source': '15',
        'target': '22',
        'type': '2'
      },
      {
        'id': '21',
        'source': '15',
        'target': '23',
        'type': '2'
      },
      {
        'id': '22',
        'source': '13',
        'target': '24',
        'type': '0'
      },
      {
        'id': '23',
        'source': '25',
        'target': '18',
        'type': '0'
      }
    ]
  };



// WEBPACK FOOTER //
// ./components/Agile/portfolioDashboard/data.js